<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        class="mt-4"
        small
        style="border-radius: 8px;"
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
      >
      {{ $t("newCasino.games") }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>{{ $t("newCasino.games") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          dark
          @click="dialog = false"
        >
          <v-icon right>mdi-close</v-icon>
        </v-btn> 
      </v-toolbar>
      <v-container class="pt-6">
        <v-row>
          <v-col
            v-for="(game, index) in campaign.games"
            :key="game.game_id"
            cols="4"
          >
            <div
              v-if="!$vuetify.breakpoint.mdAndUp"
              class="d-flex justify-center align-center"
              @click.stop="cardClick(campaign.games[index]), campaign.id"
            >
              <div class="d-flex flex-column align-center" style="gap: 12px">
                <v-icon 
                  v-if="showIcon.includes(game.game_id)"
                  size="100"
                >
                  mdi-image
                </v-icon>
                <div v-else>
                  <v-img
                    width="96"
                    style="border-radius: 1rem;"
                    :src="
                      encodeURI(
                        `https://cdn.softswiss.net/i/s3/${
                          campaign.games[index].game_identifier.split(':')[0]
                        }/${
                          campaign.games[index].game_identifier.split(':')[1]
                        }.png`.replace(/\s/g, '')
                      )
                    "
                    @error="imgError(game.game_id)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        v-if="loading"
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <v-overlay :value="loadingOpenGameCard">
                    <v-progress-circular
                      indeterminate
                      size="64"
                    ></v-progress-circular>
                  </v-overlay>
                </div>
                <div class="caption">
                  {{ game.game_name }}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <ItemDialog
        :dialog="itemDialog"
        type="lobby"
        :categoryName="currentGameDialog ? currentGameDialog.categoryName : ''"
        :item="currentGameDialog"
        @closeItemDialog="closeItemDialog"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import ItemDialog from "@/views/home/casinoNew/components/item/itemDialog.vue";
export default {
  props: {
    campaign: {
      type: Object,
    },
    loading: {
      type: Function,
    },
    disabled: {
      type: Boolean
    }
  },

  components: {
    ItemDialog
  },

  data: () => ({
    showIcon: [],
    dialog: false,
    gamesDialogsOpened: [],
    openingGameDialog: 0,
    currentGameDialog: {},
    itemDialog: false,
    loadingOpenGameCard: false
  }),

  methods: {
    imgError(gameId) {
      this.showIcon.push(gameId);
    },

    cardClick(game, campaignId) {

      if (this.openingGameDialog !== 0) {
        return;
      }

      const gameId = game.game_id;

      const gameAlreadyOpened = this.gamesDialogsOpened.find(
        (game) => game.game_id === gameId
      );

      if (gameAlreadyOpened) {
        this.currentGameDialog = gameAlreadyOpened;
        this.itemDialog = true;
        return;
      }

      this.openingGameDialog = gameId;
      this.openingGameCampaign = campaignId;
      this.loadingOpenGameCard = true;

      this.$request
        .post("/player/online/casino/game", { game_id: gameId, status: "1" })
        .then((res) => {
          const game = res.data.dados;

          game.game_id = gameId;
          game.src = encodeURI(
            `https://cdn.softswiss.net/i/s3/${
              game.identifier_game.split(":")[0]
            }/${game.identifier_game.split(":")[1]}.png`.replace(/\s/g, "")
          );
          game.categories = game.categories.split(",");
          game.categoryName = game.categories[0];
          game.providerImage = encodeURI(
            `https://cdn.softswiss.net/logos/providers/white/${
              game.identifier_game.split(":")[0]
            }.svg`.replace(/\s/g, "")
          );
          game.key = `${gameId}-${game.id_provider}`;

          this.gamesDialogsOpened.push(game);
          this.currentGameDialog = game;
          this.itemDialog = true;
        })
        .finally(() => {
          this.openingGameDialog = 0;
          this.loadingOpenGameCard = false;
        });

    },
    closeItemDialog() {
      this.currentGameDialog = {};
      this.itemDialog = false;
    },
  }
}
</script>

<style>
.loadingCard {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 1000;
}
</style>